import React, { ComponentProps, ReactElement } from 'react';

import ContentLoader from '@adsk/alloy-react-content-loader';
import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType } from '@adsk/alloy-react-theme';

import { DEFAULT_TABLE_SIZE } from '../consts';
import useTableSize from '../hooks/useTableSize';

type SkeletonLoadingVertebraProps = ComponentProps<typeof ContentLoader>;

const SKELETON_RADIUS = 8;
const SKELTON_HEIGHT = 12;

const toPx = (value: string | number | undefined): number =>
  typeof value === 'number' ? value : parseInt(value ?? '', 10) || 0;

const SkeletonLoadingVertebra = ({
  width: widthProp = 20,
  height: heightProp,
  ...props
}: SkeletonLoadingVertebraProps): ReactElement => {
  const theme = useTheme();
  const defaultRowHeight = useTableSize(DEFAULT_TABLE_SIZE).rowHeight;
  const horizontalPadding = toPx(
    theme.tokens?.component?.table?.skeleton?.['horizontal-padding'],
  );
  let width = typeof widthProp === 'string' ? parseInt(widthProp) : widthProp;
  width = width - horizontalPadding;
  const rowHeight = toPx(heightProp ?? defaultRowHeight);

  const yCentered = rowHeight / 2 - SKELTON_HEIGHT / 2;

  return (
    <div css={{ width, height: rowHeight }}>
      <ContentLoader width={width} height={rowHeight} {...props}>
        <rect
          y={yCentered}
          rx={SKELETON_RADIUS}
          ry={SKELETON_RADIUS}
          width={width}
          height={SKELTON_HEIGHT}
        />
      </ContentLoader>
    </div>
  );
};

SkeletonLoadingVertebra.propTypes = {
  style: stylePropType,
};

export default SkeletonLoadingVertebra;
